<template>
  <div>
    <!-- begin::Quick Panel -->
    <div id="kt_quick_panel" ref="kt_quick_panel" class="offcanvas offcanvas-left pt-5 pb-10" style="overflow: hidden;">
      <!--begin::Header-->
      <div class="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
        <div class="offcanvas-close mt-n1 pr-5">
          <a href="#" class="btn btn-xs btn-icon btn-light btn-hover-primary" id="kt_quick_panel_close">
            <i class="ki ki-close icon-xs text-muted"></i>
          </a>
        </div>
      </div>
      <!--end::Header-->
      <div class="mx-auto">
        <v-container>
          <div class="container-quickpanel">
            <div>

              <h3>{{$t("quickActionsPanel.contentTitle")}}</h3>
              
              <div class="v-cards-quickPanel mb-8">
                <router-link :to="{ name: 'gestionContenus', query: { selected: 'tab-themes'}}">
                  <v-card class="mb-3">
                    <v-card-title class="pl-2 ">{{$t("quickActionsPanel.addTheme")}}</v-card-title>
                  </v-card>
                </router-link>
                <router-link :to="{ name: 'creerVideo', query: { selected: 'tab-videos'}}">
                  <v-card class="mb-3">
                    <v-card-title class="pl-2 ">{{$t("quickActionsPanel.addVideo")}}</v-card-title>
                  </v-card>
                </router-link>
                <router-link :to="{ name: 'creerParcours', query: { selected: 'tab-parcours'}}">
                  <v-card class="mb-3">
                    <v-card-title class="pl-2 ">{{$t("quickActionsPanel.addCourse")}}</v-card-title>
                  </v-card>
                </router-link>
              </div>

            </div>   
            <div>

              <h3>{{$t("quickActionsPanel.clientTitle")}}</h3>
              
              <div class="v-cards-quickPanel">
                <router-link :to="{ name: 'creerClient', query: { selected: 'tab-clients'}}">
                  <v-card class="mb-3">
                    <v-card-title class="pl-2 ">{{$t("quickActionsPanel.addClient")}}</v-card-title>
                  </v-card>
                </router-link>
                <router-link :to="{ name: 'creerDroitUtilisateur', query: { selected: 'tab-userRights'}}">
                  <v-card class="mb-3">
                    <v-card-title class="pl-2 ">{{$t("quickActionsPanel.addUserRight")}}</v-card-title>
                  </v-card>
                </router-link>
                <router-link :to="{ name: 'creerUtilisateur', query: { selected: 'tab-users'}}">
                  <v-card class="mb-3">
                    <v-card-title class="pl-2 ">{{$t("quickActionsPanel.addUser")}}</v-card-title>
                  </v-card>
                </router-link>
              </div>

            </div>
          </div>
          <!-- <v-spacer></v-spacer> -->
        </v-container>
      </div>
    </div>
    <!-- end::Quick Panel -->
  </div>
</template>

<style lang="scss" scoped>

  @media (max-width: 600px){
    .v-cards-quickPanel{
      margin-bottom: 20px !important;
    }
    .container-quickpanel{
      padding-right: 10px;
      padding-left: 10px;
    }
    .v-card__title{
      padding-top: 0px !important;
      padding-bottom: 0px !important;
    }
  }
</style>

<script>
import KTLayoutQuickPanel from "@/assets/js/layout/extended/quick-panel.js";

export default {
  name: "KTQuickPanel",
  data() {
    return {};
  },
  mounted() {
    // Init Quick Offcanvas Panel
    KTLayoutQuickPanel.init(this.$refs["kt_quick_panel"]);
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      // set current active tab
      event.target.classList.add("active");
    },
  },
};
</script>
